import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * Manual Routes and Pages
 */
const ListManualPage = React.lazy(() => import("./ListManualPage"));
const AddManualPage = React.lazy(() => import("./AddManualPage.js"));
const EditManualPage = React.lazy(() => import("./EditManualPage"));

const ManualRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListManualPage />} />
      <Route exact path="/add" element={<AddManualPage />} />
      <Route exact path="/edit/:id" element={<EditManualPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default ManualRoutes;
